import { render, staticRenderFns } from "./AssetSpecs.vue?vue&type=template&id=b864ae0e&"
import script from "./AssetSpecs.vue?vue&type=script&lang=js&"
export * from "./AssetSpecs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports